// src/styles/GlobalStyles.js
import React from 'react';
import { GlobalStyles as MuiGlobalStyles } from '@mui/material';
import { border } from '@mui/system';

const GlobalStyles = () => {

    const styles = {

        "@media (min-width: 600px)": {

        }
    };

    return <MuiGlobalStyles styles={styles} />;
};

export default GlobalStyles;
